import { cn } from '@/utils/cn'

export const FINANCE_CHAMADOS_FLOW = [
  {
    status: 'NOVO',
    title: 'Abertura',
    description: 'Protocolo gerado e chamado entra na fila do financeiro.',
  },
  {
    status: 'EM_ANALISE',
    title: 'Triagem',
    description: 'O time financeiro analisa, prioriza e atribui responsável.',
  },
  {
    status: 'AGUARDANDO',
    title: 'Interação',
    description: 'Pode solicitar dados, documentos ou aprovação interna.',
  },
  {
    status: 'CONCLUIDO',
    title: 'Encerramento',
    description: 'Concluído ou cancelado após resolução da demanda.',
  },
] as const

type Props = {
  variant?: 'compact' | 'full'
  className?: string
}

export function FinanceChamadosWorkflow({ variant = 'full', className }: Props) {
  if (variant === 'compact') {
    return (
      <p className={cn('text-sm leading-relaxed text-[#5f6b7a] dark:text-text-muted', className)}>
        Seu chamado vai para a{' '}
        <strong className='font-medium text-[#172b4d] dark:text-text-primary'>
          fila do financeiro Agrada
        </strong>{' '}
        (aba Chamados no CRM). Um analista assume, pode pedir informações e você acompanha status e
        SLA aqui no portal.
      </p>
    )
  }

  return (
    <div
      className={cn(
        'rounded-xl border border-[#dfe1e6] bg-white p-4 shadow-sm sm:p-5 dark:border-white/10 dark:bg-bg-card',
        className,
      )}
    >
      <h3 className='text-sm font-semibold text-[#172b4d] dark:text-text-primary'>
        Fluxo dos chamados
      </h3>
      <p className='mt-1 text-xs text-[#6b778c] dark:text-text-muted'>
        Solicitações do portal PJ e do CRM seguem o mesmo fluxo na fila financeira.
      </p>
      <ol className='mt-4 grid gap-3 sm:grid-cols-2 lg:grid-cols-4'>
        {FINANCE_CHAMADOS_FLOW.map((step, index) => (
          <li
            key={step.status}
            className='relative rounded-lg border border-[#e8edf5] bg-[#f8fafc] p-3 dark:border-white/10 dark:bg-white/5'
          >
            <span className='inline-flex h-6 w-6 items-center justify-center rounded-full bg-emerald-600 text-xs font-bold text-white'>
              {index + 1}
            </span>
            <p className='mt-2 text-sm font-semibold text-[#172b4d] dark:text-text-primary'>
              {step.title}
            </p>
            <p className='mt-1 text-xs leading-relaxed text-[#6b778c] dark:text-text-muted'>
              {step.description}
            </p>
          </li>
        ))}
      </ol>
    </div>
  )
}
